module.exports = __webpack_public_path__ + "908e4d2e/img/cadBim.e369a02a.png";